import React from 'react';
import { Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import FormFooter from '../../../common/forms/FormFooter';
import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import { isRequired, validateEndDate } from '../../../../utils/validators';

const validateToDate = (value, allValues) =>
  validateEndDate(value, allValues.fromDateString);

const DriverTaskSummaryMovementsForm = ({ handleSubmit, loading }) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label="Desde" required>
        <Field
          name="fromDateString"
          component={TextInput}
          type="date"
          showTollTip
          placeholder="Fecha inicial"
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Hasta" required>
        <Field
          name="toDateString"
          component={TextInput}
          type="date"
          placeholder="Fecha final"
          showTollTip
          validate={[isRequired, validateToDate]}
        />
      </FormItem>
    </FormGroup>
    <FormFooter
      saveButtonColor="primary"
      saveButtonText="Buscar"
      saveButtonIcon="fa fa-search"
      saveButtonDisabled={loading}
    />
  </Form>
);

DriverTaskSummaryMovementsForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

DriverTaskSummaryMovementsForm.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ TrafficUnit }) => ({
  loading: TrafficUnit.DriverTaskSummary.getIn(['movements', 'loading']),
});

const formComponent = reduxForm({
  form: 'DriverTaskSummaryMovementsForm',
})(DriverTaskSummaryMovementsForm);

export default connect(mapStateToProps, null)(formComponent);